import { Map } from 'immutable';
import { actions } from './actions';

const initialState = new Map({
  platform: '',
  deviceId: '',
  nickname: '',
  delta: 0,
  developer: new Map({
    count: 5, // when this is 0, we're in development mode
    branch: process.env.BRANCH_NAME || 'local',
  }),
  location: new Map({
    name: '',
    id: '',
  }),
  hash: process.env.BUNDLE_VERSION,
});

export default function reducer(state = initialState, { type, value }) {
  switch (type) {
    case actions.SET:
      return new Map(value);
    case actions.CLEAR:
      return initialState;
    case actions.SET_DEVICE_ID:
      return state.set('deviceId', value);
    case actions.SET_PLATFORM:
      return state.set('platform', value);
    case actions.SET_NICKNAME:
      return state.set('nickname', value);
    case actions.SET_LOCATION:
      return state.set('location', new Map(value));
    case actions.UPDATE_TIME_DELTA:
      return state.set('delta', value);
    case actions.DECREMENT_DEVELOPER:
      return state.updateIn(['developer', 'count'], devCount => devCount - 1);
    case actions.SET_UPDATE_HASH:
      return state.set('hash', value);
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/device/reducer.js